(function($) {
  "use strict";
// let's go...
// ======================================================================================================


/*------------------------------------*\
    #document.ready
\*------------------------------------*/
$(document).ready(function() {

    // fitvids
    $('body').fitVids();

    $(".animsition").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 500,
        outDuration: 500,
        linkElement: 'a:not([target="_blank"]):not([href^="#"]):not([href^="tel:"]):not([class*="js-swipebox"]):not([id*="swipebox"])',
        // e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
        loading: true,
        loadingParentElement: 'body', //animsition wrapper element
        loadingClass: 'animsition-loading',
        loadingInner: '', // e.g '<img src="loading.svg" />'
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: [ 'animation-duration', '-webkit-animation-duration'],
        // "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
        // The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
        overlay : false,
        overlayClass : 'animsition-overlay-slide',
        overlayParentElement : 'body',
        transition: function(url){ window.location.href = url; }
    });


    /*---------------------------------------
        #Sticky header
    ---------------------------------------*/
    var sticky = new Waypoint.Sticky({
        element: $('.js-sticky')[0]
    });

    /*---------------------------------------
        Masory gallery
    ---------------------------------------*/
    var $grid = $('.js-gallerymasonry').imagesLoaded( function() {
        $grid.masonry();
    });


    $( '.js-swipebox' ).swipebox({
        useSVG: false,
        hideBarsDelay : 300000,
    });

    /*------------------------------------*\
        #Show/hide menu
    \*------------------------------------*/
    $(document).on('click', '.js-show-menu', function(e){
        e.preventDefault();
        $('body').toggleClass('is-menuopen');
    });


    /*------------------------------------*\
        #Tabs
    \*------------------------------------*/
    $('.js-tabs').first().addClass('is-current');
    $('.js-tabs-content').first().addClass('is-current');
    $(document).on('click', '.js-tabs', function(e){
        e.preventDefault();
        var tab_id = $(this).attr('data-tab');
        $('.js-tabs, .js-tabs-content').removeClass('is-current');
        $(this).addClass('is-current');
        $("#"+tab_id).addClass('is-current');
    });



    /*---------------------------------------
        #home slider
    ---------------------------------------*/
    var $homeSlider = $('.js-homeslider').flickity({
        contain        : true,
        autoPlay       : 7000,
        prevNextButtons: false,
        pageDots       : true,
        wrapAround     : true,
        adaptiveHeight : true,
        imagesLoaded   : true,
    });
    $( window ).on( 'load', function() {
        $homeSlider.flickity('resize');
    });
    /*---------------------------------------
        #winner slider
    ---------------------------------------*/
    var $winnersSlider = $('.js-winners').flickity({
        contain        : true,
        prevNextButtons: false,
        imagesLoaded   : true,
        wrapAround     : false,
        groupCells     : true,
        adaptiveHeight : true,
    });
    var $previousButtonWinnersSlider = $('.js-winners-prev').on( 'click', function(e) {
        e.preventDefault();
        $winnersSlider.flickity('previous');
    });
    var $nextButtonWinnersSlider = $('.js-winners-next').on( 'click', function(e) {
        e.preventDefault();
        $winnersSlider.flickity('next');
    });
    $( window ).on( 'load', function() {
        $winnersSlider.flickity('resize');
    });
    /*---------------------------------------
        #Home winner slider
    ---------------------------------------*/
    // var $HomeWinnersSlider = $('.js-homewinnersslider').flickity({
    //     contain        : true,
    //     prevNextButtons: false,
    //     imagesLoaded   : true,
    //     wrapAround     : false,
    //     groupCells     : true,
    //     adaptiveHeight : true,
    //     pageDots       : false,
    // });
    // var $previousButtonHomeWinnersSlider = $('.js-winners-prev').on( 'click', function(e) {
    //     e.preventDefault();
    //     $HomeWinnersSlider.flickity('previous');
    // });
    // var $nextButtonHomeWinnersSlider = $('.js-winners-next').on( 'click', function(e) {
    //     e.preventDefault();
    //     $HomeWinnersSlider.flickity('next');
    // });
    // $( window ).on( 'load', function() {
    //     $HomeWinnersSlider.flickity('resize');
    // });
    /*---------------------------------------
        #Home winners carousel
    ---------------------------------------*/
    function updateStatus() {
        var cellNumber = flkty.selectedIndex + 1;
        $HomeWinnersSliderStatus.text( cellNumber + '/' + flkty.slides.length );
    }
    if ( $('.js-homewinnersslider').length ) {
        var $HomeWinnersSlider = $('.js-homewinnersslider').flickity({
            groupCells     : true,
            contain        : true,
            prevNextButtons: false,
            pageDots       : false,
            wrapAround     : false,
            draggable      : true,
            imagesLoaded   : true,
            adaptiveHeight : true,
        });
        var $HomeWinnersSliderStatus = $('.js-homewinnersslidercounter');
        var flkty = $HomeWinnersSlider.data('flickity');
        updateStatus();
        $HomeWinnersSlider.on( 'select.flickity', updateStatus );
        $( window ).on( 'load', function() {
            $HomeWinnersSlider.flickity('resize');
        });
        /* previous */
        var $HomeWinnersSliderPreviousButton = $('.js-homewinnersslider-prev').on( 'click', function(e) {
            e.preventDefault();
            $HomeWinnersSlider.flickity('previous');
        });
        /* next */
        var $HomeWinnersSliderNextButton = $('.js-homewinnersslider-next').on( 'click', function(e) {
            e.preventDefault();
            $HomeWinnersSlider.flickity('next');
        });
    }




});
// ----------------------------------
// END - document.ready


// ======================================================================================================
// the end
})(jQuery);
